import React from "react";
import LeftServiceButtonSection1 from "./section1Left/LeftServiceButtonSection1";
import LeftServiceCardSection1 from "./section1Left/LeftServiceCardSection1";
import LeftServiceRecentSection1 from "./section1Left/LeftServiceRecentSection1";
import RightServiceSection1 from "./section1Right/RightServiceCardSection1";

const ServiceSection1 = () => {
  return (
    <div id="headlines">
      <div className="mx-auto w-[90%] flex-row-reverse lg:flex">
        <div className="lg:ml-56 lg:mt-16">
          <RightServiceSection1 row="top" />

          <RightServiceSection1 row="middle" />

          {/* <RightServiceSection1 row="bottom" /> */}
        </div>

        <div className="left lg:mx-8 mt-36 lg:w-[35rem]">
          <LeftServiceCardSection1 />
          {/* <LeftServiceCardSection1 /> */}
          <div className="mt-16">
            <h1 className="text-3xl font-medium">Time & Notice</h1>
            <hr className="mt-4 border-black" />
            <ul className="space-y-3 text-xl text-gray-800">
              <LeftServiceRecentSection1
                title="Meeting Timing"
                para=" 8:00am - 10:00am"
              />
              <LeftServiceRecentSection1
                title="Notice"
                para="Today is a survey induction "
              />
              {/* <LeftServiceRecentSection1 /> */}
            </ul>
          </div>

          <div className="mt-16">
            <h1 className="text-3xl font-medium">News Post</h1>
            <hr className="mt-4 border-black" />
            <div className="mt-8 space-y-3 text-lg">
              <LeftServiceButtonSection1 row="top" />
              <LeftServiceButtonSection1 row="bottom" />
              {/* <LeftServiceButtonSection1 />
            <LeftServiceButtonSection1 />
            <LeftServiceButtonSection1 />
            <LeftServiceButtonSection1 />
            <LeftServiceButtonSection1 />
            <LeftServiceButtonSection1 />
            <LeftServiceButtonSection1 />
            <LeftServiceButtonSection1 /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSection1;
